import { ObjectKeyMappingModel } from '../custom-data/models/object-key-mapping.model';

export const objectKeyMappings = {
  // NauticalCountryModel
  $nautical_country_id: new ObjectKeyMappingModel(
    'Nautical',
    'nautical',
    'Country',
    'country',
    ['id'],
    ['name', 'isO2']
  ),

  // NauticalPortModel
  $nautical_port_id: new ObjectKeyMappingModel(
    'Nautical',
    'nautical',
    'Port',
    'port',
    ['id'],
    ['name', 'unloCode']
  ),

  // NauticalShipModel
  $nautical_ship_id: new ObjectKeyMappingModel(
    'Nautical',
    'nautical',
    'Ship',
    'ship',
    ['id'],
    [
      'name',
      'imo',
      'loa',
      'mmsi',
      'gt',
      'eni',
      'flagCode',
      'callSign',
      'fisheryNumber',
      'shipType',
      'width',
      'dwt',
      'maxDraft',
    ]
  ),

  // NauticalVisitModel
  $nautical_portvisit_id: new ObjectKeyMappingModel(
    'Nautical',
    'nautical',
    'Port Visit',
    'portvisit',
    ['id', 'referenceNumber'],
    ['referenceNumber', 'eta', 'etd', 'ata', 'atd', 'status']
  ),
  $nautical_portvisit_referencenumber: new ObjectKeyMappingModel(
    'Nautical',
    'nautical',
    'Port Visit',
    'portvisit',
    ['id', 'referenceNumber'],
    ['referenceNumber']
  ),

  // NauticalMovementModel
  $nautical_portmovement_id: new ObjectKeyMappingModel(
    'Nautical',
    'nautical',
    'Port Movement',
    'portmovement',
    ['id'],
    ['ata', 'atd']
  ),

  // NauticalWaypointModel
  $nautical_portwaypoint_id: new ObjectKeyMappingModel(
    'Nautical',
    'nautical',
    'Port Waypoint',
    'portwaypoint',
    ['id'],
    ['code', 'name']
  ),

  // NauticalWaypointModel
  $nautical_harbour_id: new ObjectKeyMappingModel(
    'Nautical',
    'nautical',
    'Harbour',
    'harbour',
    ['id'],
    ['code', 'name']
  ),

  // CompanyModel
  $companies_company_id: new ObjectKeyMappingModel(
    'Companies',
    'companies',
    'Company',
    'company',
    ['id'],
    ['name', 'id']
  ),

  // FinancialModel
  $companies_financial_id: new ObjectKeyMappingModel(
    'Companies',
    'companies',
    'Financial',
    'financial',
    ['id'],
    ['debtorNumber', 'emailAddress']
  ),

  // UserModel
  $usermanager_user_id: new ObjectKeyMappingModel(
    'Users',
    'usermanager',
    'User',
    'user',
    ['id'],
    ['givenName', 'surname']
  ),

  // InvoiceModel
  $invoicing_invoice_id: new ObjectKeyMappingModel(
    'Invoicing',
    'invoicing',
    'Invoice',
    'invoice',
    ['id'],
    ['number', 'description', 'totalAmount']
  ),
  $invoicing_tariff_id: new ObjectKeyMappingModel(
    'Invoicing',
    'invoicing',
    'Tariff',
    'tariff',
    ['id', 'systemCode'],
    ['name']
  ),
};
